module.exports = __webpack_public_path__ + "img/gas-valve-old.8273107a.png";